export default __webpack_public_path__ + "static/media/schoo_pic.ad8e2df0.png";